"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
/* global window */

var _context = void 0;

try {
  _context = window;
} catch (e) {
  _context = global;
}

var context = _context;

exports["default"] = context;


//////////////////
// WEBPACK FOOTER
// ../node_modules/@catalytic/pushbot-ui/util/context.js
// module id = 93
// module chunks = 32